import React from 'react';

import type { SkeletonShapeProps } from '../types';

type ContextValue = Readonly<{
	loading: boolean;
	shapeColorClassName: string;
	shapeSize: SkeletonShapeProps['size'];
}>;

const SkeletonContext = React.createContext<ContextValue>({
	loading: false,
	shapeColorClassName: '',
	shapeSize: 'medium',
});

export const useSkeletonContext = () => React.useContext(SkeletonContext);

export const SkeletonProvider: React.FC<Props> = (props) => {
	const parent = useSkeletonContext();
	const { loading, shapeColorClassName, shapeSize, children } = props;
	const value = React.useMemo<ContextValue>(
		() => ({
			loading: loading ?? parent.loading,
			shapeColorClassName: shapeColorClassName ?? parent.shapeColorClassName,
			shapeSize: shapeSize ?? parent.shapeSize,
		}),
		[loading, shapeColorClassName, shapeSize, parent],
	);
	return <SkeletonContext.Provider value={value}>{children}</SkeletonContext.Provider>;
};

type Props = Readonly<{
	loading?: boolean;
	shapeColorClassName?: string;
	shapeSize?: SkeletonShapeProps['size'];
	children?: React.ReactNode;
}>;
